import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { paymentConfigApi } from '@/api/commercial/payment-config';
import { toast } from '@/hooks/use-toast';
import type { PaymentConfigFormData } from '@/schemas/commercial/payment-config.schema';

export function usePaymentConfigCurrent() {
  return useQuery({
    queryKey: ['payment-config', 'current'],
    queryFn: () => paymentConfigApi.findCurrent(),
  });
}

export function usePaymentConfigHistory(page = 1) {
  return useQuery({
    queryKey: ['payment-config', 'history', page],
    queryFn: () => paymentConfigApi.findHistory({ page, limit: 5 }),
  });
}

export function useUpdatePaymentConfig() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PaymentConfigFormData) => paymentConfigApi.update(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['payment-config'] });
      toast({ title: 'Configuração de pagamento salva' });
    },
    onError: () => {
      toast({ title: 'Erro ao salvar configuração', variant: 'destructive' });
    },
  });
}
